import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import LPD from "./pages/LPD";
import Altasusuarios from "./pages/AltaUsuarios";
import BajaUsuario from "./pages/BajaUsuario";
import Informatica from "./pages/Informatica";
import Historico from "./pages/Historico";
import Logout from "./pages/Logout";
import Login from "./pages/Login";
import ProtectedRoute from "./pages/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />

        {/* Rutas protegidas */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/LPD" element={<LPD />} />
          <Route path="/altausuarios" element={<Altasusuarios />} />
          <Route path="/informatica" element={<Informatica />} />
          <Route path="/bajausuario" element={<BajaUsuario />} />
          <Route path="/historico" element={<Historico />} />
        </Route>
      </Routes>

      {/* Contenedor global de Toastify */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        pauseOnHover
        closeOnClick
        draggable
      />
    </Router>
  );
}

export default App;
